export default __webpack_public_path__ + "static/exonum-78e91d29172a0e28d56c25f13aa422d0.png";